import React from 'react';

interface LineArrowLeftIconProps {
  size?: number;
  color?: string;
}

export const LineArrowLeftIcon: React.FC<LineArrowLeftIconProps> = ({ size = 24, color = '#686868' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 20L7 12L15 4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
